/* eslint-disable @typescript-eslint/no-unused-vars */
import { IRootState } from "..";
import { IDeliveryCharge } from "src/models";
import * as Types from "src/redux/types";

export default class DeliveryChargeActions {
  public static load =
    (deliveryCharge: IDeliveryCharge) =>
    async (
      dispatch: DispatchType<Action<IDeliveryCharge>>,
      getState: () => IRootState
    ) =>
      dispatch({
        type: Types.DELIVERY_CHARGES_LOAD,
        payload: deliveryCharge,
      });
}
